module.exports = __webpack_public_path__ + "static/media/packfinder.820640cb.md";